import React from 'react';
import { Container } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

const AdminLayout: React.FC = () => {
  return (
    <Container maxW="container.xl" py={{ base: 4, md: 5 }} px={{ base: 4, md: 6 }}>
      <Outlet />
    </Container>
  );
};

export default AdminLayout; 